//请自行添加语言资源
const shipto = {
  customerCode:'客户编码',
  customerShortName:'客户简称',
  customerName: '客户名称',
  customerAddr: '客户地址',
  tradeLineCode:'贸易线编码',
  tradeLineName:'贸易线名称',
  businessType:'',
  mnemonicCode:'',
  contact:'联系人',
  tel: '联系电话',
  email:'联系邮箱',
  createTime:'创建时间',
  creator:'创建者',
  updateTime:'更新时间',
  updater:'更新者',
  msg:{
    recycleBoxNo: '请输入周转箱号起始数字',
    recycleBoxNoBegin: '请输入周转箱号结束数字',
    recycleBoxNoEnd: '请输入周转箱号',
    warehouseCode: '请选择仓库'
  }
};
export default shipto



// WEBPACK FOOTER //
// ./src/page/md/shipto/lang/shipto.zh.js